import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Badge, BadgeProps } from '@fx-ui/fine-design';

interface UnreadMessageStatusProps extends BadgeProps {
    className?: string;
    hasUnread: boolean;
}

const UnreadMessageStatus: React.FC<PropsWithChildren<UnreadMessageStatusProps>> = (props) => {
    const { className, hasUnread, children, ...restProps } = props;
    const cls = classNames('fx-unread-message-status', className);

    if (hasUnread) {
        return (
            <Badge className={cls} {...restProps}>
                <>{children}</>
            </Badge>
        );
    }

    return <div className={cls}>{children}</div>;
};

export default React.memo(UnreadMessageStatus);
